import { render, staticRenderFns } from "./RattachmentObjectInfo.vue?vue&type=template&id=d24903a8"
import script from "./RattachmentObjectInfo.vue?vue&type=script&lang=js"
export * from "./RattachmentObjectInfo.vue?vue&type=script&lang=js"
import style0 from "./RattachmentObjectInfo.vue?vue&type=style&index=0&id=d24903a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports